/* eslint-disable no-magic-numbers */
import * as yup from 'yup';
import { errorTexts } from '@features/errors';

export const countriesSchema = yup.object().shape({
  short: yup.string().max(5, errorTexts.maxLength(5)).required(errorTexts.required()),
  name: yup.string().required(errorTexts.required()),
  nameEng: yup.string().required(errorTexts.required()),
});
